import { useState } from 'react';
import { BASE_URL, FETCH_ALL_CLIENTS } from "../utility/constants";
import { axiosInstance } from '../services/axiosConfig';

const useClientList = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  // Add search param
  const fetchClients = async ({ skip = 0, limit = 10, search = '' }) => {
    setLoading(true);
    setError(null);
    try {
      let url;
      if (search) {
        // Use the search endpoint
        url = `${BASE_URL}v1/client/search?query=${encodeURIComponent(search)}&skip=${skip}&limit=${limit}`;
      } else {
        // Use the default endpoint
        url = `${BASE_URL}${FETCH_ALL_CLIENTS}?skip=${skip}&limit=${limit}`;
      }
      const res = await axiosInstance.get(url);
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, response, fetchClients };
};

export default useClientList; 